import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-amenities-dialog',
  templateUrl: './amenities-dialog.component.html',
  styleUrls: ['./amenities-dialog.component.scss']
})
export class AmenitiesDialogComponent implements OnInit {
  title;
  list;
  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef: MatDialogRef<AmenitiesDialogComponent>,) { 
    this.list = data;
    console.log(this.list);
  }

  ngOnInit(): void { }
}
